import React, { useState, useRef } from "react";
import "./InteractiveButton.css";

export const InteractiveButton = ({ 
  children, 
  className = "", 
  onClick, 
  variant = "primary", 
  style = {},
  filled = false,
  ...props 
}) => {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const buttonRef = useRef(null);

  const handleMouseEnter = (e) => {
    if (filled) return;
    const rect = buttonRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    setMousePos({ x, y });
  };

  return (
    <button
      ref={buttonRef}
      className={`hp-btn-circle ${variant ? `hp-btn--${variant}` : ""} ${filled ? 'hp-btn--filled' : ''} ${className}`}
      onMouseEnter={handleMouseEnter}
      onClick={onClick}
      style={{
        ...style,
        "--x": filled ? '50%' : `${mousePos.x}px`,
        "--y": filled ? '50%' : `${mousePos.y}px`,
      }}
      {...props}
    >
      <span className="btn-content">{children}</span>
    </button>
  );
};
